// Our Clients — Phase 1. Logos live in /public/clients. Clients without a logo
// file render as premium text cards. `href: null` = not clickable (no link yet).
export const clients = [
  {
    id: "choice-group",
    name: "The Choice Group",
    logo: "/clients/choice-group.png",
    href: "https://choicegroup.in/",
  },
  {
    id: "snowbee",
    name: "Snowbee Cold Store",
    lines: ["Snowbee", "Cold Store"],
    logo: null,
    href: "https://share.google/xQdZG0E7sRDG4QxCv",
  },
  {
    id: "mrm",
    name: "MRM Sea Food Processing",
    lines: ["MRM", "Sea Food Processing"],
    logo: null,
    href: null,
  },
  {
    id: "je-dental",
    name: "J & E Joolys & Emmanuel Dental Clinic",
    logo: "/clients/je-dental.png",
    href: "https://share.google/rdkA2RRJnugi6dEmL",
  },
  {
    id: "johns-tooth-care",
    name: "Johns Tooth Care",
    logo: "/clients/johns-tooth-care.png",
    href: "https://share.google/x8tYvbSJVmPJY1kZF",
  },
  {
    id: "kochuparambil",
    name: "Kochuparambil Dental & Orthodontic",
    logo: "/clients/kochuparambil.png",
    href: "https://www.smilewithdrjain.in/",
  },
  {
    id: "alora",
    name: "Alora Aesthetics",
    logo: "/clients/alora-aesthetics.png",
    href: "https://aloraaesthetics.in/",
  },
  {
    id: "kottayam-kaari",
    name: "Kottayam Kaari — by Sunit's Kitchen",
    lines: ["Kottayam Kaari", "by Sunit's Kitchen"],
    logo: "/clients/kottayam-kaari.png",
    href: "https://share.google/Y5uVcqMEw5vdXYcfd",
  },
  {
    id: "mountqueen",
    name: "Mountqueen — Malanad Passion Fruit Plantations",
    lines: ["Mountqueen", "Malanad Passion Fruit Plantations"],
    logo: "/clients/mountqueen.png",
    href: "https://www.instagram.com/malanadplantations?igsh=ZHk1N21mZXJlZnAy",
  },
  {
    id: "golden-caterers",
    name: "Shine's Golden Caterers",
    lines: ["Shine's", "Golden Caterers"],
    logo: "/clients/golden-caterers.png",
    href: "https://share.google/QaQHbHkmMXA9CDwh7",
  },
  {
    id: "gallus-amino",
    name: "Gallus Amino Slaughter Waste Treatment Plant",
    lines: ["Gallus Amino", "Slaughter Waste Treatment Plant"],
    logo: null,
    href: null,
  },
  {
    id: "green-growth",
    name: "Green Growth Organics",
    lines: ["Green Growth", "Organics"],
    logo: "/clients/green-growth.png",
    href: "https://www.instagram.com/green__growth__organic?utm_source=qr",
  },
  {
    id: "southside-store",
    name: "Southside Store",
    lines: ["Southside", "Store"],
    logo: "/clients/southside-store.png",
    href: "https://www.instagram.com/southsidestore.co?utm_source=qr",
  },
  {
    id: "cmc-chelad",
    name: "CMC Chelad Medical Center",
    lines: ["CMC Chelad", "Medical Center"],
    logo: null,
    href: "https://share.google/OjZXaqQt103IAQhjw",
  },
];
